module.exports = __webpack_public_path__ + "static/media/reject.97e9ba90.svg";